import { FormLayout, Modal, TextField, Toast } from '@shopify/polaris'
import { useCallback, useState } from 'react'
import Api from '../../helpers/api';

export default ({ active, location, onClose, setLocation }) => {
    const [form, setForm] = useState({
        email: '',
    });

    const [errors, setErrors] = useState({});
    const setField = name => value => setForm(state => ({
        ...state,
        [name]: value,
    }));

    const [toastActive, setToastActive] = useState(false);
    const toggleToast = useCallback(() => setToastActive((toastActive) => !toastActive), []);

    const [saving, setSaving] = useState(false);

    const submit = () => {
        setSaving(true);

        Api.createLocationCustomer(location.id, form.email)
            .then(response => {
                setLocation(response.data.data);
                onClose();
            })
            .catch(error => {
                setToastActive(true);

                if (error.response.status == 422 ) {
                    setErrors(error.response.data.errors);
                } else {
                    throw error;
                }
            })
            .finally(() => setSaving(false));
    };

    const toastMarkup = toastActive ? (
      <Toast content="There has been an error processing the form." error onDismiss={toggleToast} />
    ) : null;

    return (
        <Modal open={active}
               onClose={onClose}
               title="Give unique customer account"
               primaryAction={{
                   content: 'Submit',
                   onAction: submit,
                   disabled: saving,
               }}
               secondaryActions={[
                   {
                       content: 'Close',
                       onAction: onClose,
                   },
               ]}
        >
            <Modal.Section>
                <FormLayout>
                    <TextField label="Email"
                               value={form.email}
                               onChange={setField('email')}
                               error={errors.email} />
                </FormLayout>
            </Modal.Section>

            {toastMarkup}
        </Modal>
    )
}
